import Player from "@/components/LottiePlayer"

export default function Key({ title, children }) {
  return (
    <section className="keynote !bg-[#f2f3f5]">
      <div className="flex items-center gap-3">
        <Player autoplay loop src='/assets/icons/key.json' className="p-1 w-16 h-auto" />
        <p className="text-maingray text-2xl font-semibold">{title}</p>
      </div>
      {children &&
        <div className="text-secgray -mt-8"><ul>{children.map((i, index) => (
          <li key={index} className="-mt-1">{i}</li>
        ))}</ul></div>}
    </section>
  )
}